'use client';
import { useMantineTheme } from '@mantine/core';
import { AppProgressBar as ProgressBar } from 'next-nprogress-bar';
import React, { PropsWithChildren } from 'react';

const ProgressProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const theme = useMantineTheme();

  return (
    <>
      {children}
      <ProgressBar
        height="2px"
        color={theme.primaryColor}
        options={{ showSpinner: false }}
        shallowRouting
      />
    </>
  );
};

export default ProgressProvider;
